import { BCListbox } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { Map } from 'immutable';
import { JSX } from 'react';
import { Direction, IPropertyField } from '../../../../entities/common';
import ListBoxBase from '../../base/ListBoxBase';
import Styles from './assets/styles.scss';
import { IListBoxProperties } from './entities/IListBoxProperties';
import _merge from 'lodash/merge';

export default class ListBox extends ListBoxBase {
	direction: Direction;
	allowSelectAll: boolean;

	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.ListBox;
		this.direction = 'vertical';
		this.allowSelectAll = false;

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			const selectedKeys = JSON.parse(value);
			this.__proxyChanging.items = this.items.map(item => ({
				...item,
				selected: selectedKeys.findIndex(i => i == item.key.toString()) > -1
			}));
		});

		this.subscribe('trigger:OnSearchingChange', (value: string) => {
			this.__onSearch(value);
		});
	}

	__loadProperties(data: IListBoxProperties) {
		super.__loadProperties(data);
		this.__proxyChanged.allowSelectAll = data.allowSelectAll;
		this.__proxyChanged.direction = data.direction;
	}

	private triggerSelectedChanged(selectedKeys: string[]) {
		if (selectedKeys && selectedKeys.length) {
			this.__proxyChanging.items = this.items.map((item, index) =>
				Object.assign({}, item, {
					selected: selectedKeys.findIndex(i => i == item?.value?.toString()) > -1
				})
			);
		} else {
			this.__proxyChanging.items = this.items.map((item, index) =>
				Object.assign({}, item, { selected: false })
			);
		}
	}

	__getPropertyFields(properties?: Map<string, any>): IPropertyField[] {
		const fields = super.__getPropertyFields(properties);
		return [
			...fields,
			{
				name: 'direction',
				type: 'enum',
				enumMembers: ['horizontal', 'vertical'] as Direction[]
			},
			{
				name: 'allowSelectAll',
				type: 'boolean'
			}
		];
	}

	__getItems(): any[] {
		if (this.items) {
			return this.items.map(item => ({
				text: item.text.getText(),
				key: item.value,
				disabled: false,
				selected: item.selected
			}));
		}
		return null;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			direction: this.direction,
			allowSelectAll: this.allowSelectAll,
			options: this.__getItemsForMobile(),
			values: this.items.filter(i => i.selected).map(v => v.key)
		};
	}

	__getItemsForMobile(): any[] {
		return (
			this.items?.map(item => ({
				text: item.text.getText(),
				key: item.key,
				disabled: false,
				selected: item.selected
			})) || []
		);
	}

	__render(children?: JSX.Element) {
		return super.__render(
			<>
				<BCListbox
					items={this.__getItems()}
					direction={this.direction}
					search={this.showSearch}
					disabled={this.loading || this.__isDisabled()}
					onSearch={this.__onSearch}
					onChange={this.triggerSelectedChanged.bind(this)}
					selectAllButton={this.allowSelectAll}
					style={{ backgroundColor: this.style.backgroundColor }}
					className={Styles.fillListBox}
					readOnly={this.__isReadOnly()}
				/>
			</>
		);
	}
}
